module.exports = __webpack_public_path__ + "static/media/logo.9539e03b.png";